import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const TrademarkFooter: React.FC = () => {
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        mt: 3, 
        pt: 2, 
        borderTop: `1px solid ${theme.palette.divider}`,
        textAlign: 'center' 
      }}
    >
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ fontSize: '0.8rem' }}
      >
        © {new Date().getFullYear()} CognicoreSolutions™. All rights reserved.
      </Typography>
    </Box>
  );
};

export default TrademarkFooter; 